/* NOFILTERCLUB — Shopify theme JS
   Cart count, fade-up, mobile nav, toast, ajax add-to-cart. */
(function () {
  'use strict';

  // ---------- Toast ----------
  let toastTimer;
  function toast(msg) {
    const el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2400);
  }
  window.NFC = window.NFC || {};
  NFC.toast = toast;

  // ---------- Cart count + smart checkout label ----------
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        var n = cart.item_count || 0;
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = n;
          el.style.display = n > 0 ? '' : 'none';
        });
        // Header label: "Checkout" always; "Cart" if empty
        document.querySelectorAll('[data-cart-label]').forEach(el => {
          el.textContent = n > 0 ? 'Checkout' : 'Bag';
        });
        // Sticky mobile bar
        var bar = document.getElementById('mobileCheckoutBar');
        if (bar) {
          bar.classList.toggle('show', n > 0);
          var count = bar.querySelector('.count');
          if (count) count.textContent = n;
          var totalEl = bar.querySelector('.total');
          if (totalEl) {
            var amt = (cart.total_price / 100);
            totalEl.textContent = 'AED ' + (amt % 1 === 0 ? amt.toFixed(0) : amt.toFixed(2));
          }
        }
      })
      .catch(() => {});
  }
  NFC.updateCartCount = updateCartCount;

  // ---------- AJAX add to cart ----------
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(r => {
      if (!r.ok) return r.json().then(err => { throw new Error(err.description || 'Add to cart failed'); });
      return r.json();
    }).then(line => {
      updateCartCount();
      toast(`Added · ${line.product_title}`);
      return line;
    });
  }
  NFC.addToCart = addToCart;

  // ---------- Mobile nav ----------
  function initNav() {
    const burger = document.getElementById('navBurger');
    const nav = document.getElementById('nav');
    if (burger && nav) {
      burger.addEventListener('click', () => nav.classList.toggle('open'));
    }
  }

  // ---------- Fade-up on scroll ----------
  function initFadeUp() {
    const els = document.querySelectorAll('.fade-up');
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('in')); return; }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(ent => {
        if (ent.isIntersecting) { ent.target.classList.add('in'); obs.unobserve(ent.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    els.forEach(e => obs.observe(e));
  }

  // ---------- PDP variant selector ----------
  function initProductForm() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    const variants = JSON.parse(form.dataset.variants || '[]');
    const state = { Colour: form.dataset.defaultColour, Size: form.dataset.defaultSize };
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-price]');
    const addBtn = form.querySelector('[data-add-btn]');

    function findVariant() {
      return variants.find(v => v.option1 === state.Colour && v.option2 === state.Size);
    }
    function fmtPrice(p) {
      // Shopify variant.price is in cents (Number) when serialized via | json
      const n = typeof p === 'number' ? p / 100 : parseFloat(p);
      return `AED ${n.toFixed(2)}`;
    }
    function syncUI() {
      const v = findVariant();
      if (v) {
        variantInput.value = v.id;
        const priceText = fmtPrice(v.price);
        if (priceEl) priceEl.textContent = priceText;
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? `Add to bag — ${priceText}` : 'Sold out';
        // Swap main hero image to variant's featured image (if it has one different from current)
        if (v.featured_image && v.featured_image.src) {
          const mainImg = document.querySelector('[data-main-img]');
          if (mainImg && mainImg.src !== v.featured_image.src) {
            mainImg.src = v.featured_image.src;
          }
        }
      }
      form.querySelectorAll('[data-option="Colour"] .chip').forEach(c => {
        c.classList.toggle('active', c.dataset.value === state.Colour);
      });
      form.querySelectorAll('[data-option="Size"] .chip').forEach(c => {
        c.classList.toggle('active', c.dataset.value === state.Size);
        const exists = variants.some(v => v.option1 === state.Colour && v.option2 === c.dataset.value && v.available);
        c.classList.toggle('disabled', !exists);
      });
      const picked = { Colour: state.Colour, Size: state.Size };
      Object.keys(picked).forEach(k => {
        const el = form.querySelector(`[data-picked="${k}"]`);
        if (el) el.textContent = picked[k];
      });
    }
    form.addEventListener('click', e => {
      const chip = e.target.closest('.chip[data-value]');
      if (!chip || chip.classList.contains('disabled')) return;
      const opt = chip.closest('[data-option]').dataset.option;
      state[opt] = chip.dataset.value;
      // Mirror selection into the size <select> if present
      const sel = form.querySelector('[data-size-select]');
      if (opt === 'Size' && sel) sel.value = state.Size;
      syncUI();
    });

    // Native size select (added for non-techie UX)
    const sizeSelect = form.querySelector('[data-size-select]');
    if (sizeSelect) {
      sizeSelect.addEventListener('change', () => {
        state.Size = sizeSelect.value;
        syncUI();
      });
    }

    form.addEventListener('submit', e => {
      e.preventDefault();
      const v = findVariant();
      if (!v || !v.available) return;
      const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      addToCart(v.id, qty)
        .then(() => { window.location.href = '/cart'; })
        .catch(err => { toast(err.message); addBtn.disabled = false; syncUI(); });
    });

    // Express Checkout — adds to cart and jumps straight to /checkout (skips bag review)
    const expressBtn = form.querySelector('[data-express-btn]');
    if (expressBtn) {
      expressBtn.addEventListener('click', e => {
        e.preventDefault();
        const v = findVariant();
        if (!v || !v.available) return;
        const qty = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
        expressBtn.disabled = true;
        expressBtn.textContent = 'Loading checkout…';
        addToCart(v.id, qty)
          .then(() => { window.location.href = '/checkout'; })
          .catch(err => { toast(err.message); expressBtn.disabled = false; expressBtn.textContent = 'EXPRESS CHECKOUT →'; });
      });
    }

    // Quantity stepper
    const qtyInput = form.querySelector('[name="quantity"]');
    const qtyMinus = form.querySelector('[data-qty-minus]');
    const qtyPlus = form.querySelector('[data-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', () => { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1); });
      qtyPlus.addEventListener('click', () => { qtyInput.value = Math.min(10, parseInt(qtyInput.value || '1', 10) + 1); });
    }

    // Thumbnail switcher
    document.querySelectorAll('.pdp-thumb').forEach(t => {
      t.addEventListener('click', () => {
        document.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
        const main = document.querySelector('[data-main-img]');
        if (main) main.src = t.dataset.img;
      });
    });

    syncUI();
  }

  // ---------- Quick add (homepage cards) ----------
  // Adds to cart, then sends user straight to /cart so the Checkout button is right there.
  function initQuickAdd() {
    document.querySelectorAll('[data-add-variant]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const id = btn.getAttribute('data-add-variant');
        if (!id) return;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'ADDING…';
        addToCart(id, 1)
          .then(() => {
            btn.textContent = 'ADDED ✓ → BAG';
            // Hard redirect to cart so the user lands on the Checkout button
            setTimeout(() => { window.location.href = '/cart'; }, 500);
          })
          .catch(err => {
            toast(err.message || 'Could not add — please try again');
            btn.textContent = original;
            btn.disabled = false;
          });
      });
    });
  }

  // ---------- Init on load ----------
  document.addEventListener('DOMContentLoaded', () => {
    initNav();
    initFadeUp();
    initProductForm();
    initQuickAdd();
    updateCartCount();
  });
})();
